import { createContext, type ReactNode } from 'react';
import type { ModalAction } from 'src/components/ModalContainer';

export interface BulkEditorStepValue {
  /** Whether the modal state still has the editor open; the pushed step pops itself once it does not. */
  isOpen: boolean;
  title: string;
  /** Back is added by the step itself, wired to its own pop. */
  primaryAction?: ModalAction;
  children: ReactNode;
}

/**
 * A pushed step is stored as an element when it opens, so its props would freeze there. The editor
 * reads its live title, actions and fields from this context instead, provided above the dialog.
 */
export const BulkEditorStepContext = createContext<BulkEditorStepValue | null>(null);
